var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('placeholder-panel',{staticClass:"user-placeholder"},[_c('h1',{staticClass:"display-4 text-center mb-2"},[_vm._v(" 👈 ")]),_c('h5',{staticClass:"text-center font-weight-bold mb-0"},[_vm._v(" 請選擇用戶 ")])])}
var staticRenderFns = []

export { render, staticRenderFns }